const common = {
  // Navbar
  nav_home: '首页',
  nav_about: '关于我们',
  nav_products: '产品展示',
  nav_design: '设计理念',
  nav_partners: '合作伙伴',
  nav_contact: '联系我们',

  // Hero
  hero_badge: '2025新品系列',
  hero_eyebrow: 'CYAN CHARM · Street Style',
  hero_title_1: '自由行走',
  hero_title_2: '街头风尚',
  hero_title_3: '由你定义',
  hero_desc: '灵感源自点滴生活，融合户外自由与都市精致。每一款包，都是你最好的出行伴侣。',
  hero_cta_explore: '探索产品',
  hero_cta_story: '品牌故事',

  // About
  about_title_1: '精湛工艺',
  about_title_highlight: '优质皮料',
  about_title_2: '重新定义女包美学',
  about_label_material: '臻选皮料',
  about_label_design: '原创设计',
  about_label_craft: '精工细作',
  about_origin_badge: '品牌起源',
  about_slogan_1: '始于热爱',
  about_slogan_2: '成于匠心',
  about_slogan_3: '精于创新',
  about_desc: '我们相信，每一位女性都值得拥有一款完美的包。从2015年创立至今，我们始终坚持将时尚美学融入产品设计，运用优质皮料与精湛工艺，为都市女性打造兼具颜值与实用的高端女包。',
  about_learn_more: '了解更多',
  about_review: '这是我买过最满意的包包。设计感十足，皮质柔软细腻，容量也很大，上班、约会都完全hold住。每次背出去都会被朋友问在哪里买的！',
  about_reviewer_name: '林晓雯',
  about_reviewer_title: '时尚博主 · 上海',
  about_more_reviews: '查看更多评价',

  // Products
  products_badge: '全部系列',
  products_title_1: '精选女包',
  products_title_2: '为她而生',
  products_view_detail: '查看详情',
  products_view_all: '查看全部产品',
  product_1_name: 'Élite Tote',
  product_1_category: '托特包系列',
  product_2_name: 'Chic Shoulder',
  product_2_category: '单肩包系列',
  product_3_name: 'Luxe Clutch',
  product_3_category: '手拿包系列',
  product_4_name: 'Mini Charm',
  product_4_category: '迷你包系列',

  // Design
  design_title_highlight_1: '可持续',
  design_title_1: '设计理念',
  design_title_2: '融合',
  design_title_highlight_2: '时尚美学',
  design_label_eco: '环保材质研发',
  design_label_creative: '创意设计',
  design_label_craft: '匠心工艺',
  design_quote_light: '设计',
  design_quote_bold: '源于对美的热爱',
  design_explore: '探索设计故事',
  design_eco_title: '环保先行',
  design_eco_desc: '采用100%可回收皮料与环保染色工艺，减少碳足迹，为地球的可持续发展贡献力量。',
  design_original_title: '原创设计',
  design_original_desc: '每季推出全新原创系列，融合东西方美学，让每一款包都成为独一无二的时尚宣言。',
  design_quality_title: '匠心品质',
  design_quality_desc: '每一道工序都经过严格把控，手工缝制与精密五金，确保产品经久耐用，陪伴每一天。',

  // Partners
  partners_badge: '合作品牌',
  partners_title_1: '携手共创',
  partners_title_2: '时尚未来',
  partners_desc: '我们与全球领先时尚品牌建立深度合作，共同探索女包设计的无限可能。从时尚媒体到明星联名，从环保公益到奢华酒店，每一次合作都是对品质的承诺。',
  partners_cta: '成为合作伙伴',
  partner_1_name: 'Vogue China',
  partner_1_desc: '时尚媒体合作',
  partner_2_name: 'Luxury Hotels',
  partner_2_desc: '酒店专属礼品',
  partner_3_name: 'Fashion Week',
  partner_3_desc: '时装周联名款',
  partner_4_name: 'Eco Alliance',
  partner_4_desc: '环保公益项目',
  partner_5_name: 'Celebrity Style',
  partner_5_desc: '明星联名系列',

  // Contact
  contact_title_light: '关注我们',
  contact_title_bold: '随时保持联系',
  contact_xhs_label: '小红书',
  contact_xhs_desc: '扫码关注，获取穿搭灵感',
  contact_dy_label: '抖音',
  contact_dy_desc: '扫码关注，探索时尚新品',
  contact_wx_label: '微信',
  contact_wx_desc: '扫码关注，获取专属优惠',
  contact_address_label: '地址',
  contact_address_value: '中国广东省广州市白云区',
  contact_email_label: '邮箱',
  contact_phone_label: '电话',

  // Footer
  footer_brand_desc: '专注于打造高端潮流女包\n融合时尚美学与精湛工艺\n为都市女性提供卓越体验',
  footer_subscribe_title: '订阅资讯',
  footer_subscribe_placeholder: '输入您的邮箱',
  footer_privacy: '隐私政策',
  footer_subscribe_tip: '订阅即表示同意我们的',
  footer_links_title: '快速链接',
  footer_follow_title: '关注我们',
  footer_copyright: '© 2025 Luxe Bag. All rights reserved.',
};

export default common;
